<section class="ced-nota" aria-label="Nota fiscal do pedido">
  <div class="ced-nota-cabecalho">
    <div class="ced-nota-titulo">
      <mat-icon class="material-symbols-outlined ced-nota-titulo-icone">receipt_long</mat-icon>
      <h3>Nota fiscal do pedido</h3>
      @if (carregando) { <mat-spinner diameter="18" aria-label="Carregando nota fiscal"></mat-spinner> }
    </div>
    <p class="ced-nota-apoio">
      {{ temNota
        ? 'Confira a nota vinculada: associação dos itens, vínculo com o pedido e saldo recebido.'
        : 'Escolha a nota do pedido na lista abaixo, importe o XML ou lance a nota manualmente.' }}
    </p>
  </div>

  @if (bloqueio) {
    <app-alert-card type="warning" icon="lock" title="Vínculo com a NF travado.">{{ bloqueio }}</app-alert-card>
  } @else if (erro) {
    <app-alert-card type="warning" icon="lock" title="Ações da NF indisponíveis.">{{ erro }}</app-alert-card>
  }

  @for (contexto of contextos; track contexto.nota.idNFeEntrada) {
    <div class="ced-nota-cartao">
      <div class="ced-nota-corpo">
        <span class="ced-nota-icone">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
        </span>
        <div class="ced-nota-textos">
          <div class="ced-nota-linha-titulo">
            <span class="ced-nota-numero">NF-e {{ contexto.nota.numero || '—' }}/{{ contexto.nota.serie || '—' }}</span>
            @if (isVinculoConfirmado(contexto)) {
              <span class="status-badge badge-verde ced-nota-pilula">
                <mat-icon class="material-symbols-outlined">check_circle</mat-icon>VÍNCULO CONFIRMADO
              </span>
            } @else {
              <span class="status-badge badge-amarelo ced-nota-pilula">
                <mat-icon class="material-symbols-outlined">schedule</mat-icon>VÍNCULO PENDENTE
              </span>
            }
            @if (isAssociacaoPendente(contexto)) {
              <span class="status-badge badge-vermelho ced-nota-pilula">
                <mat-icon class="material-symbols-outlined">link_off</mat-icon>ASSOCIAÇÃO PENDENTE
              </span>
            }
          </div>
          @if (contexto.nota.chaveAcesso) {
            <div class="ced-nota-chave">Chave {{ contexto.nota.chaveAcesso }}</div>
          }
          <div class="ced-nota-meta">
            {{ contexto.nota.nomeEmitente || contexto.nota.cnpjEmitente || 'Emitente não informado' }}
            @if (contexto.nota.dataEmissao) { · Emissão {{ contexto.nota.dataEmissao | date: 'dd/MM/yyyy' }} }
          </div>
          @if (outrosPedidos(contexto)) {
            <div class="ced-nota-consolidada">
              <mat-icon class="material-symbols-outlined">merge</mat-icon>Consolidada com {{ outrosPedidos(contexto) }}
            </div>
          }
          <div class="ced-nota-rodape">
            @if (!ocultarQuantidades) {
              <span class="ced-nota-dado">
                Qtd. vinculada
                @if (isMultiplasUnidades) {
                  <b>@for (u of quantidadeVinculadaNotaPorUnidade(contexto); track u.unidade) {<span>{{ $first ? '' : ' · ' }}{{ u.quantidade | abnt: 'quantidade' }} {{ u.unidade }}</span>} @empty {<span>—</span>}</b>
                } @else {
                  <b>{{ quantidadeVinculadaNota(contexto) | abnt: 'quantidade' }}{{ unidadePedido ? ' ' + unidadePedido : '' }}</b>
                }
              </span>
            }
            <span class="ced-nota-dado">
              Valor <b>{{ contexto.nota.valorTotal !== null ? (contexto.nota.valorTotal | abnt: 'preco' : 2) : '—' }}</b>
            </span>
            @if (!ocultarQuantidades) {
              <button mat-button type="button" class="btn-section ced-nota-abrir" (click)="abrirNota(contexto.nota.idNFeEntrada)"
                matTooltip="Abrir a nota em nova aba">
                <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Abrir nota
              </button>
            }
          </div>
        </div>
      </div>

      <div class="ced-nota-faixa" [class.ced-nota-faixa-ok]="isTudoVinculado(contexto)">
        <mat-icon class="material-symbols-outlined ced-nota-faixa-icone">
          {{ isTudoVinculado(contexto) ? 'check_circle' : 'bolt' }}
        </mat-icon>
        <div class="ced-nota-faixa-textos">
          <div class="ced-nota-faixa-topo">
            <span class="ced-nota-faixa-caption">
              {{ isAssociacaoPendente(contexto) ? 'Itens da NF associados' : 'Itens da NF vinculados' }}
            </span>
            <span class="status-badge badge-cinza ced-nota-progresso">{{ itensProgresso(contexto) }} de {{ contexto.itens.length }}</span>
          </div>
          <div class="ced-nota-faixa-texto">
            @if (isAssociacaoPendente(contexto)) {
              Associação de itens pendente — associe os itens do XML aos produtos do sistema antes do vínculo com o pedido.
            } @else if (isTudoVinculado(contexto)) {
              Todos os itens da NF estão vinculados aos itens do pedido de compra.
            } @else {
              Vínculo pendente — conclua para liberar a Conferência.
            }
          </div>
        </div>
        <span class="ced-nota-faixa-acao" [matTooltip]="motivoAcoesBloqueadas" [matTooltipDisabled]="!motivoAcoesBloqueadas">
          @if (isAssociacaoPendente(contexto)) {
            <button mat-flat-button type="button" class="btn-primary" (click)="abrirVinculo(contexto.nota.idNFeEntrada)"
              [disabled]="carregando || somenteLeitura || !!erro || !!bloqueio">
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Associar itens
            </button>
          } @else if (isTudoVinculado(contexto)) {
            <!-- Na Conferência o vínculo fica como está (a contagem é feita contra ele) e "Itens da nota" já o mostra. -->
            @if (!ocultarQuantidades && card.stage !== 'conferencia') {
              <button mat-stroked-button type="button" class="btn-secondary" (click)="abrirVinculo(contexto.nota.idNFeEntrada)"
                [disabled]="carregando || somenteLeitura || !!erro || !!bloqueio">
                <mat-icon class="material-symbols-outlined">visibility</mat-icon> Rever vínculo
              </button>
            }
          } @else {
            <button mat-flat-button type="button" class="btn-primary" (click)="abrirVinculo(contexto.nota.idNFeEntrada)"
              [disabled]="carregando || somenteLeitura || !!erro || !!bloqueio">
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Abrir vínculo
            </button>
          }
        </span>
      </div>
    </div>
  }

  @if (contextos.length && !ocultarQuantidades) {
    <div class="ced-nota-saldo">
      <mat-icon class="material-symbols-outlined">inventory</mat-icon>
      <span>
        @if (detalhe?.itens?.length && isMultiplasUnidades) {
          @for (l of saldoPorUnidade; track l.unidade) {<span>{{ $first ? '' : ' · ' }}{{ l.unidade }}: {{ l.recebida | abnt: 'quantidade' }} de {{ l.pedida | abnt: 'quantidade' }}</span>}
          recebidas ·
          @for (l of saldoPendentePorUnidade; track l.unidade) {<span>{{ $first ? 'saldo pendente de ' : ' · ' }}{{ l.saldo | abnt: 'quantidade' }} {{ l.unidade }}</span>} @empty {<span>saldo zerado</span>}
        } @else if (detalhe?.itens?.length) {
          {{ quantidadeVinculadaPedido | abnt: 'quantidade' }} de {{ quantidadePedida | abnt: 'quantidade' }}{{ unidadePedido ? ' ' + unidadePedido : '' }} recebidas
          · {{ saldoPedido > 0 ? 'saldo pendente de ' + (saldoPedido | abnt: 'quantidade') : 'saldo zerado' }}
        } @else {
          Quantidade vinculada: {{ quantidadeVinculadaPedido | abnt: 'quantidade' }}
        }
      </span>
    </div>
  }

  <!-- Na Conferência a carga já está sendo contada contra esta NF: trocar a nota invalidaria a contagem. -->
  @if (temNota && !bloqueio && card.stage !== 'conferencia') {
    <div class="ced-nota-acoes">
      <span [matTooltip]="motivoAcoesBloqueadas" [matTooltipDisabled]="!motivoAcoesBloqueadas">
        <button mat-stroked-button type="button" class="btn-secondary" [attr.aria-pressed]="trocandoNota"
          [disabled]="carregando || somenteLeitura || !!erro" (click)="trocandoNota = !trocandoNota">
          <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon> Trocar NF
        </button>
      </span>
    </div>
  }

  @if (isAvancoBloqueado) {
    <app-alert-card type="neutral" icon="lock" title="Avanço bloqueado.">
      Entrar em Conferência exige todos os itens da NF associados e vinculados ao pedido.
    </app-alert-card>
  }

  @if (!temNota || (trocandoNota && !bloqueio)) {
    <h3 class="ced-nota-seletor-titulo">{{ temNota ? 'Escolha a nota que substitui a atual' : 'Selecione a nota fiscal' }}</h3>
    <app-seletor-nota-fiscal [idCompra]="card.idCompra!" [bloqueado]="somenteLeitura || !!erro || !!bloqueio"
      [motivoBloqueio]="motivoAcoesBloqueadas" [ocupado]="carregando" (notaEscolhida)="abrirVinculo($event)"></app-seletor-nota-fiscal>
  }
</section>
